import { useTheme } from '@emotion/react';
import { Box } from '@mui/material';
import './Disclaimer.css';

interface DisclaimerProps {
  text: string
}

const Disclaimer:React.FC<DisclaimerProps> = ({ text }) => {
  const theme:any = useTheme();

  return (
    <div className="REQXXI-Disclaimer-note" >
      <Box
        className="REQXXI-Disclaimer"
        sx={{ p: '16px', color: theme.palette?.error.light }}
      >
        {text}
      </Box>
    </div>
  );
};

export default Disclaimer;
